import { ReactNode, Suspense } from 'react';
import { Route, RouteProps } from 'react-router-dom';
import { useUser, useAuth, AuthStates } from '@increasecard/increase-core';
import { FullPageSpinner } from './components/common/FullPageSpinner';

export interface PrivateRouteProps extends RouteProps {
  children: ReactNode;
}

export function PrivateRoute({
  children,
  ...rest
}: PrivateRouteProps): JSX.Element | null {
  const authState = useAuth({ requireAuth: true });
  const user = useUser();

  if (authState.state !== AuthStates.Authenticated || !user) return null;

  return (
    <Route
      {...rest}
      render={() => (
        <Suspense fallback={<FullPageSpinner height="calc(100vh - 56px)" />}>
          {children}
        </Suspense>
      )}
    />
  );
}
